import { render, staticRenderFns } from "./IAOut.vue?vue&type=template&id=12af0120&scoped=true"
import script from "./IAOut.vue?vue&type=script&lang=js"
export * from "./IAOut.vue?vue&type=script&lang=js"
import style0 from "./IAOut.vue?vue&type=style&index=0&id=12af0120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af0120",
  null
  
)

export default component.exports